import React, { useState, useEffect, useContext } from "react";
import "./pastOrders.scss";
// External Compnents
import Axios from "axios"; // Axios for api calling
import { Button } from "@material-ui/core"; //Material Ui
import { withTranslation, useTranslation, Trans } from 'react-i18next'  //Localization
// Internal Components
import Page from "../Page";
import LoaderAnimation from "../LoaderAnimation";
import StateContext from "../../StateContext";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PastOrderUi from "../pastOrdersUi/pastOrdersUi"
import { handleError } from "../../Functions/getAlert";
import DispatchContext from "../../DispatchContext";



function NoOrders() {
  const { t } = useTranslation();
  return (
    <>
      <div className="empBox">
        <div className="text-center py-5">
          <div className="BoxImg">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}box.png`}
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="mt-1">
            <p className="text-secondary">
              <strong>{t("status.order-not-found")}</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function AllOrders(props) {
  const { appState, t, allOrders, setPaginate, paginate } = props;
  return (
    <>
      <div id="pastOrdersParent" className="data-content__dashboard">
        <div className="data-row__dashboardv2">
          <DateWiseOrders appState={appState} t={t} allOrders={allOrders} setPaginate={setPaginate} paginate={paginate} />
        </div>
      </div>
    </>
  );
}

function DateWiseOrders(props) {
  const { t, setPaginate, paginate, allOrders } = props

  const handlePaginate = () => {
    let count = paginate + 5
    setPaginate(count)
  }
  return (
    <>
      <div className="row justify-content-center  pt-5 m-0">
        {
          <React.Fragment>
            {allOrders.map((order, index) => {
              return (
                <div className="prodContainer col-md-12 px-0" key={index}>
                  <PastOrderUi orderDetails={order} key={index} />
                </div>
              )
            })}
          </React.Fragment>
        }
      </div>
      <div className="d-flex pb-3 justify-content-center align-items-center">
        <Button className="viewAll" variant="text" onClick={handlePaginate}>
          {" "}
          {t("drawer.view-more")}
          {props.appState.langValue === "ar"
            ? <KeyboardArrowLeftIcon />
            : <KeyboardArrowRightIcon />}
        </Button>
      </div>
    </>
  );
}
function PastOrders(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginate, setPaginate] = useState(10)
  const [first_page_url, setFirst_page_url] = useState("customer/invoice?paginate=10&page=1");
  const [next_page_url, setNext_page_url] = useState("")

  // console.log(paginate)

  const { t } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.post(
          next_page_url != "" ? next_page_url : `${process.env.REACT_APP_API_URL}${first_page_url}`, {
          service_status: ["Completed", "Rejected"]
        },

          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        // console.log(response)
        setIsLoading(true);
        if (response.data.success === true) {
          // console.log(response.data.data.data)
          var orders_categories = response.data.data.data;
          var arryOrders = [...orders];
          for (var i = 0; i < orders_categories.length; i++) {
            let order = orders_categories[i];
            arryOrders.push(order);
          }
          setOrders(arryOrders != [] ? arryOrders : []);
          if(response.data.data.next_page_url !== null){
            const nextPageKeyword = response.data.data.next_page_url;
            let checknextPageKeyword =
              nextPageKeyword !== null ? nextPageKeyword.includes("https") : "";
            // console.log(checknextPageKeyword)
            const replaceHttps = nextPageKeyword.replace(/http/gi, "https")
            setNext_page_url(checknextPageKeyword ? nextPageKeyword : replaceHttps)
          }else{
            setNext_page_url(response.data.data.last_page_url)
          }
         
          props.setCount(arryOrders.length);
          setIsLoading(false);


        }
      } catch (e) {
        setIsLoading(false);
        handleError(e, appDispatch)
        Promise.reject(e);
      }
    };
    fetchData();

  }, [paginate]);
  // console.log(orders)
  if (isLoading)
    return (
      <div style={{ position: "relative", height: "250px" }}>
        {/* <CircularProgress /> */}
        <LoaderAnimation />
      </div>
    );
  if (orders.length > 0) {
    return (
      <Page title="Orders">
        <AllOrders appState={appState} t={t} allOrders={orders} setPaginate={setPaginate} paginate={paginate} />
      </Page>
    );
  } else {
    return (

      <Page title="Orders">
        <NoOrders />
      </Page>
    );
  }
}

export default withTranslation()(PastOrders);
